import * as Types from '../generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CustomerQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type CustomerQuery = { __typename?: 'Query', customer?: { __typename?: 'CustomerNode', id: string, address?: string | null, additionalAddress?: string | null, city?: string | null, zip?: number | null, country?: string | null, phone?: string | null, additionalPhone?: string | null, email?: string | null, fax?: string | null, isActive: boolean, additionalFax?: string | null, bankAccountNumber?: string | null, standingOrderLimit?: number | null, branchNumber?: string | null, name: string, oldNumber?: number | null, type: Types.CustomersCustomerTypeChoices, title?: Types.CustomersCustomerTitleChoices | null, companyNumber?: string | null, contactName?: string | null, shouldUnionInvoices: boolean, accountManager?: { __typename?: 'MeNode', id: string, email?: string | null, firstName?: string | null, lastName?: string | null } | null, bank?: { __typename?: 'BankNode', id: string, name: string } | null } | null };


export const CustomerDocument = gql`
    query Customer($id: ID!) {
  customer(id: $id) {
    id
    address
    additionalAddress
    accountManager {
      id
      email
      firstName
      lastName
    }
    bank {
      id
      name
    }
    city
    zip
    country
    phone
    additionalPhone
    email
    fax
    isActive
    additionalFax
    bankAccountNumber
    standingOrderLimit
    branchNumber
    name
    oldNumber
    type
    title
    companyNumber
    contactName
    shouldUnionInvoices
  }
}
    `;

/**
 * __useCustomerQuery__
 *
 * To run a query within a React component, call `useCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerQuery(baseOptions: Apollo.QueryHookOptions<CustomerQuery, CustomerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, options);
      }
export function useCustomerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerQuery, CustomerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerQuery, CustomerQueryVariables>(CustomerDocument, options);
        }
export type CustomerQueryHookResult = ReturnType<typeof useCustomerQuery>;
export type CustomerLazyQueryHookResult = ReturnType<typeof useCustomerLazyQuery>;
export type CustomerQueryResult = Apollo.QueryResult<CustomerQuery, CustomerQueryVariables>;